// Cart Drawer JavaScript

// Initialize discount code modal
function initDiscountModal() {
	const discountToggle = document.getElementById('discount-code-toggle');
	const discountModal = document.getElementById('discount-code-modal');
	const closeModal = document.getElementById('close-discount-modal');

	if (discountToggle && discountModal && closeModal) {
		// Remove existing listeners to prevent duplicates
		discountToggle.replaceWith(discountToggle.cloneNode(true));
		const newDiscountToggle = document.getElementById('discount-code-toggle');
		
		newDiscountToggle.addEventListener('click', () => {
			discountModal.classList.add('active');
		});

		closeModal.addEventListener('click', () => {
			discountModal.classList.remove('active');
		});

		discountModal.addEventListener('click', (e) => {
			if (e.target === discountModal) {
				discountModal.classList.remove('active');
			}
		});
	}
}

// Apply Discount
function applyDiscount() {
	const discountCode = document.getElementById("discountCode").value;
	
	if(discountCode) {
		const discountModal = document.getElementById('discount-code-modal');
		// Close the modal first
		if (discountModal) {
			discountModal.classList.remove('active');
		}
		
		// Store flag to reopen cart after reload
		sessionStorage.setItem('reopenCart', 'true');
		
		// Apply the discount
		window.location.href = '/discount/' + discountCode;
	}
}

// Initialize Klaviyo form modal
function initKlaviyoModal() {
	const klaviyoToggle = document.getElementById('klaviyo-form-toggle');
	const klaviyoModal = document.getElementById('klaviyo-form-modal');
	const closeModal = document.getElementById('close-klaviyo-modal');

	if (klaviyoToggle && klaviyoModal && closeModal) {
		// Remove existing listeners to prevent duplicates
		klaviyoToggle.replaceWith(klaviyoToggle.cloneNode(true));
		const newKlaviyoToggle = document.getElementById('klaviyo-form-toggle');
		
		newKlaviyoToggle.addEventListener('click', () => {
			klaviyoModal.classList.add('active');
		});

		closeModal.addEventListener('click', () => {
			klaviyoModal.classList.remove('active');
		});

		klaviyoModal.addEventListener('click', (e) => {
			if (e.target === klaviyoModal) {
				klaviyoModal.classList.remove('active');
			}
		});
	}
}

// Initialize gift drawer
function initGiftDrawer() {
	const openGiftDrawer = document.querySelector('.open_gift_drawer');
	const giftDrawer = document.querySelector('.gift-drawer');
	
	if (openGiftDrawer && giftDrawer) {
		openGiftDrawer.addEventListener('click', () => {
			giftDrawer.classList.add('open');
		});
	}
}

// Reopen cart drawer after applying discount
function checkReopenCart() {
	if (sessionStorage.getItem('reopenCart') === 'true') {
		sessionStorage.removeItem('reopenCart');
		setTimeout(function() {
			const cartDrawer = document.getElementById('Cart-Drawer');
			if (cartDrawer) {
				cartDrawer.classList.add('active');
				document.body.classList.add('open-cart');
				document.body.classList.add('open-cc');
			}
		}, 100);
	}
}

// Initialize all cart drawer functionality
function initCartDrawer() {
	initDiscountModal();
	initKlaviyoModal();
	initGiftDrawer();
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initCartDrawer);
} else {
	initCartDrawer();
}

// Check for cart reopen
checkReopenCart();

// Reinitialize when cart drawer updates
document.addEventListener('cart:refresh', function() {
	setTimeout(initCartDrawer, 100);
});

// Also listen for cart drawer open event
document.addEventListener('cart-drawer:open', function() {
	setTimeout(initCartDrawer, 100);
});
